import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CustomElementTypeTabsSelector from 'common/components/CustomElementTypeTabsSelector';

import NoImage from 'common/icons/NoImage';
import BannerImage from 'common/icons/BannerImage';
import LogoImage from 'common/icons/LogoImage';

import { NONE_TYPE, BANNER_TYPE, LOGO_TYPE } from 'common/entities/form/styleConfiguration/constants';
import { containerPaddingS } from 'common/styles/variables';

const ImageTypeContainer = styled.div`
    margin-bottom: ${(props) => (props.hasMargin ? containerPaddingS : 0)};
`;

const NONE_LABEL = 'None';
const BANNER_LABEL = 'Banner';
const LOGO_LABEL = 'Logo';

const TAB_ELEMENTS = [
    {
        icon: NoImage,
        label: NONE_LABEL,
        value: NONE_TYPE,
    },
    {
        icon: BannerImage,
        label: BANNER_LABEL,
        value: BANNER_TYPE,
    },
    {
        icon: LogoImage,
        label: LOGO_LABEL,
        value: LOGO_TYPE,
    },
];

const FormImageTypeSelector = ({ imageType, onChangeTab, qaId }) => (
    <ImageTypeContainer hasMargin={imageType !== NONE_TYPE}>
        <CustomElementTypeTabsSelector
            value={imageType}
            tabs={TAB_ELEMENTS}
            onChange={onChangeTab}
            qaId={qaId}
            border={false}
        />
    </ImageTypeContainer>
);

FormImageTypeSelector.propTypes = {
    imageType: PropTypes.oneOf([NONE_TYPE, BANNER_TYPE, LOGO_TYPE]).isRequired,
    onChangeTab: PropTypes.func.isRequired,
    qaId: PropTypes.string.isRequired,
};

export default FormImageTypeSelector;
